// extracted by mini-css-extract-plugin
module.exports = {"packageTitle":"packageTitle_2Z-lMB7C","dot":"dot_20TEcFwV"};